export default __webpack_public_path__ + "static/media/refresh.fcdc0924.svg";